import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Error raised when there is an overlap between two intervals.
 *
 * @param {string} spec.leftInterval - string representation of the left interval
 * @param {string} spec.rightInterval - string representation of the right interval
 */
export default class OverlappingIntervalsValidationResult extends AbstractChartOfAccountsValidationResult {
	constructor(spec) {
		super(spec);

		this._leftInterval = spec.leftInterval;
		this._rightInterval = spec.rightInterval;
	}

	getLeftInterval() {
		return this._leftInterval;
	}

	getRightInterval() {
		return this._rightInterval;
	}

	getMessage() {
		return _(
			'Interval "{leftInterval}" overlaps with interval "{rightInterval}"',
			{
				leftInterval: this._leftInterval,
				rightInterval: this._rightInterval,
			},
		);
	}

	static getType() {
		return "OverlappingIntervalsValidationResult";
	}
}
